import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/usr/src/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _query, _query2, _query3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRouter } from 'next/router';
import { Typography } from "@vc-workspace/utils-typography";
import Sheet from 'react-modal-sheet';
import { UtilsSeparator } from '@vc-workspace/utils-separator';
import { useState } from "react";
import { DIMENSIONS } from "@vc-workspace/utils-dimens";
import { SortByKey } from "@vc-workspace/utils-constants";
/* eslint-disable-next-line */

var SortOptions = [{
  label: 'Relevancy',
  value: 'score',
  active: true,
  query: (_query = {}, _defineProperty(_query, SortByKey, 'score'), _defineProperty(_query, 'sortOrder', 'DESC'), _query),
  itemCount: 0
}, {
  label: 'Low Pricing',
  value: 'sellingPrice',
  query: (_query2 = {}, _defineProperty(_query2, SortByKey, 'sellingPrice'), _defineProperty(_query2, 'sortOrder', 'ASC'), _query2),
  itemCount: 0
}, {
  label: 'High Pricing',
  value: 'sellingPrice',
  query: (_query3 = {}, _defineProperty(_query3, SortByKey, 'sellingPrice'), _defineProperty(_query3, 'sortOrder', 'DESC'), _query3),
  itemCount: 0
}];
export function SortFilterModalSheet(props) {
  var _useState = useState(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var router = useRouter();
  var sortOptions = SortOptions; // Check for string in substring and array both

  if (props.context.query[SortByKey]) {
    sortOptions = sortOptions.map(function (item) {
      if (item.value === props.context.query[SortByKey] && item.query.sortOrder === props.context.query['sortOrder']) {
        item.active = true;
      } else {
        item.active = false;
      }

      return item;
    });
  }

  function addToHistory() {
    window.history.pushState(null, 'modal-sheet');
    window.hasUserTrigerredBack = false;
    window.addEventListener('popstate', function (event) {
      window.hasUserTrigerredBack = true;
      setOpen(false);
    });
  }

  function removeFromHistory() {
    if (!window.hasUserTrigerredBack) {
      window.history.back();
    }
  }

  function onItemClick(item) {
    window.hasUserTrigerredBack = true;
    router.push({
      pathname: props.context.pathname,
      query: _objectSpread(_objectSpread({}, props.context.query), {}, {
        'page': 1
      }, item.query)
    });
    setOpen(false);
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Typography, {
      type: "SubHeading1",
      color: "dim_grey",
      onClick: function onClick() {
        return setOpen(true);
      },
      semi_bold: true,
      children: [/*#__PURE__*/_jsx("img", {
        src: "/_mp-images/ic_sort.png",
        className: "inline-block w-5"
      }), /*#__PURE__*/_jsx("span", {
        className: "align-middle pl-2",
        children: "Sort"
      })]
    }), /*#__PURE__*/_jsxs(Sheet, {
      isOpen: isOpen,
      onClose: function onClose() {
        return setOpen(false);
      },
      onOpenStart: addToHistory,
      onCloseEnd: removeFromHistory,
      snapPoints: [200],
      children: [/*#__PURE__*/_jsxs(Sheet.Container, {
        children: [/*#__PURE__*/_jsx(Sheet.Header, {
          children: /*#__PURE__*/_jsx(Typography, {
            type: "SubHeading1",
            color: "dim_grey",
            className: "p-4",
            children: "Sort By"
          })
        }), /*#__PURE__*/_jsx(UtilsSeparator, {
          spacingTop: DIMENSIONS.px_0,
          spacingBottom: DIMENSIONS.px_0,
          color: "gainsboro"
        }), /*#__PURE__*/_jsx(Sheet.Content, {
          children: /*#__PURE__*/_jsx("div", {
            className: "p-4",
            children: sortOptions.map(function (item) {
              return /*#__PURE__*/_jsx(Typography, {
                className: "pb-4",
                type: "SubHeading1",
                color: "nero",
                onClick: function onClick() {
                  return onItemClick(item);
                },
                semi_bold: item.active,
                children: item.label
              }, item.value);
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Sheet.Backdrop, {
        onTap: function onTap() {
          return setOpen(false);
        }
      })]
    })]
  });
}
export default SortFilterModalSheet;